
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35148',
  depVersions: {
  "documents-public-ui": "static-1.35148",
  "atom": "static-1.5346",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2755",
  "client-types": "static-1.494",
  "cssUtils": "static-1.877",
  "customer-data-filters-ui": "static-1.40798",
  "customer-data-objects": "static-1.7948",
  "customer-data-property-utils": "static-1.8359",
  "documents-lib": "static-1.35153",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.362",
  "FormsCommonComponents": "static-1.86491",
  "FormUrlGenerator": "static-2.4988",
  "foundations-theming-specialty": "static-1.2444",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5855",
  "hs-test-utils": "static-1.8289",
  "hub-http": "static-1.6473",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12051",
  "HubStyleTokens": "static-2.11744",
  "I18n": "static-7.1665",
  "icons": "static-2.675",
  "jasmine-immutable": "static-1.3283",
  "jasmine-runner": "static-1.6713",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7413",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3158",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5658",
  "quartz": "static-1.7396",
  "react": "static-7.191",
  "react-dlb": "static-1.87",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16972",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5528",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8440",
  "reference-resolvers-lite": "static-1.8361",
  "reporting-data": "static-1.68653",
  "reporting-reports": "static-1.68330",
  "reporting-snowflake": "static-1.57270",
  "reporting-testing-lib": "static-1.10586",
  "reporting-visualizations": "static-1.60728",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9210",
  "sanitize": "static-1.4736",
  "sanitize-text": "static-1.8412",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2008",
  "signup-constants": "static-1.19538",
  "signup-ui-url-generator": "static-2.8320",
  "StyleGuideUI": "static-3.497",
  "superstore": "static-1.5017",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5016",
  "ui-addon-form-validation": "static-1.11246",
  "ui-asset-management-lib": "static-1.11356",
  "ui-images": "static-2.1233",
  "UIComponents": "static-3.8690",
  "usage-tracker": "static-1.7617",
  "usage-tracker-container": "static-1.7607",
  "usage-tracker-core": "static-1.7467",
  "viral-links-lib": "static-1.7334",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9918",
  "foundations-components": "static-1.8420",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1174",
  "quartz-core": "static-1.6615",
  "quick-fetch": "static-1.4104",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4923",
  "ui-addon-i18n": "static-1.11404",
  "ui-addon-upgrades": "static-9.18333",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3591",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3673",
  "quartz-webpack": "static-1.3620",
  "foundations-assets": "static-1.5144",
  "foundations-theming": "static-1.4728",
  "hub-http-janus": "static-1.871",
  "hub-http-shared-msw-handlers": "static-1.10550",
  "hubspotter-http": "static-1.4836",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7510",
  "crm-message-bus": "static-1.43670",
  "customer-data-filters-ui-msw-helpers": "static-1.23233",
  "customer-data-objects-ui-components": "static-1.13290",
  "customer-data-reference-ui-components": "static-1.13440",
  "customer-data-ui-utilities": "static-1.10088",
  "events-data-lib": "static-1.501",
  "framework-builder-read-service-client": "static-1.4195",
  "hs-resources": "static-1.452",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4030",
  "multi-account-reference-resolvers": "static-1.1259",
  "onboarding-scopes": "static-1.6715",
  "onboarding-tours": "static-1.17061",
  "pulse": "static-1.885",
  "reporting-datasets-permissions-lib": "static-1.14393",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2521",
  "trellis-components": "static-1.2540",
  "trellis-theming": "static-1.1227",
  "ui-addon-teams": "static-1.21868",
  "quartz-auth": "static-1.1071",
  "ui-business-units-lib": "static-1.9344",
  "usage-tracker-session-replay": "static-1.5303",
  "ai-components-ui-library": "static-1.9628",
  "ContentUtils": "static-1.69063",
  "customer-data-properties": "static-1.52473",
  "forms-ai-lib": "static-1.4710",
  "forms-utils-lib": "static-1.13039",
  "foundations-components-test-utils": "static-1.5903",
  "react-dnd-compat": "static-1.4876",
  "react-tinymce": "static-1.55904",
  "tinymce-config": "static-2.55030",
  "ui-gdpr-components": "static-1.10617",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3713",
  "HeadJS": "static-2.791",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3400",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.266",
  "ui-fonts": "static-1.1006",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4577",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1061",
  "web-vitals": "static-1.11",
  "batch-promise": "static-1.1802",
  "external-options-client-types": "static-1.4313",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7153",
  "quartz-i18n": "static-1.1071",
  "frontend-preferences-client": "static-1.8187",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3959",
  "reporting-client-types": "static-1.2652",
  "apollo-stack-hubspot": "static-3.90",
  "growth-payments-core": "static-1.26102",
  "hubspot-apollo-client": "static-1.5139",
  "foundations-components-legacy": "static-1.1445",
  "quartz-routing": "static-1.826",
  "hs-story-utils": "static-1.9687",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.496",
  "seat-types-lib": "static-1.655",
  "timezone-utils": "static-2.5507",
  "react-create-root-preference": "static-1.64",
  "bend-plugin-foundations-components": "static-1.4689",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.30",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.571",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.405",
  "quartz-test": "static-1.1071",
  "quartz-tracking": "static-1.775",
  "bend-plugin-chirp-manifest": "static-1.333",
  "chirp-fetch": "static-1.2154",
  "merchandise-lib": "static-1.274",
  "purchase-motions-components": "static-1.6299",
  "salesImages": "static-1.532",
  "ts-schema": "static-1.4267",
  "bender-build-tools": "static-1.3397",
  "bend-plugin-foundations-theming": "static-1.3211",
  "restore-request-side-panel-lib": "static-1.1589",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4916",
  "conditional-properties-service-client": "static-1.3986",
  "crm-pipelines-api-client-types": "static-1.4321",
  "event-emitter": "static-1.1214",
  "fdsr-migration-layer": "static-1.272",
  "multi-currency-client-types": "static-1.3882",
  "getting-started-shared-tasks": "static-1.19146",
  "growth-data-modal": "static-1.5838",
  "growth-onboarding-confetti": "static-1.3323",
  "growth-onboarding-next-action-utils": "static-1.2622",
  "navigation-components": "static-1.18739",
  "onboarding-tours-client": "static-1.5275",
  "onboarding-tours-utils": "static-1.1127",
  "ui-shepherd-react": "static-3.10526",
  "ui-shepherd-tracker": "static-1.7907",
  "ui-universal-auth": "static-1.9320",
  "user-context": "static-1.5378",
  "bend-plugin-pulse": "static-1.388",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10548",
  "magpie-lib": "static-1.5727",
  "navigation-messaging": "static-1.8066",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22715",
  "copilot-toolkit": "static-1.11774",
  "cms-field-types": "static-1.5075",
  "content-icons-ui": "static-1.2324",
  "integrations-lib": "static-1.16957",
  "calling-global-api": "static-1.65432",
  "calling-internal-common": "static-1.31579",
  "calling-lifecycle-internal": "static-1.66814",
  "calling-lifecycle-messages": "static-1.59108",
  "commerce-products-lib": "static-1.10443",
  "crm-index-visualization-core": "static-1.4491",
  "crm-links": "static-1.6587",
  "customer-data-properties-shared-msw-handlers": "static-1.9877",
  "file-manager-components": "static-1.24396",
  "formula-editor": "static-1.14693",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4398",
  "meetings-icalendar-utils-lib": "static-1.896",
  "object-builder-ui-client": "static-1.49577",
  "pipeline-validation-client-types": "static-1.4155",
  "property-value-citations": "static-1.3087",
  "smart-data-capture-core": "static-1.55",
  "smart-property-lib": "static-1.8204",
  "tiered-pricing": "static-1.1893",
  "topics-actions-lib": "static-1.425",
  "trial-components-library": "static-1.14044",
  "ui-addon-iframeable": "static-1.9335",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20252",
  "tinymce-themes": "static-1.57000",
  "data-token-picker": "static-1.16834",
  "hub-http-contrib": "static-1.3298",
  "interframe": "static-3.5016",
  "tinymce-data": "static-1.41115",
  "tinymce-plugins": "static-1.58144",
  "ui-addon-sales-email": "static-1.5476",
  "framework-data-schema-quick-fetch": "static-1.7058",
  "ui-addon-opt": "static-4.8627",
  "hubspot-apollo-cache": "static-1.598",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6302",
  "onboarding-data-sync-lib": "static-1.2437",
  "growth-onboarding-next-action-components": "static-1.2650",
  "user-context-client": "static-1.4769",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5187",
  "nest": "static-1.496",
  "reactive-lib": "static-1.982",
  "simple-logging-lib": "static-1.3311",
  "unified-auth-core-lib": "static-1.1116",
  "getting-started-shared-tasks-store": "static-1.18264",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1608",
  "integrations-error-boundary-lib": "static-1.14372",
  "integrations-tracking-lib": "static-1.5868",
  "native-integrations-shared-strings": "static-1.8038",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10629",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.834",
  "calling-error-reporting": "static-1.31586",
  "shared-worker-versioning": "static-1.11300",
  "calling-usage-tracker": "static-1.6799",
  "voice-sms-access-library": "static-1.1942",
  "customer-data-tracking": "static-1.7142",
  "commerce-permissions": "static-1.1037",
  "products-iframe-lib": "static-1.8520",
  "products-ui-components-shared-msw-handlers": "static-1.10932",
  "crm-index-associations-lib": "static-1.6703",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10633",
  "sales-views-client-types": "static-1.4517",
  "location-customization-utils-lib": "static-1.10018",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4412",
  "video-components-external": "static-1.12086",
  "video-data-lib": "static-1.35744",
  "bark-lib": "static-1.16767",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6150",
  "react-codemirror": "static-1.10899",
  "data-agent-kit": "static-1.591",
  "feedback-loader": "static-1.29754",
  "fsm": "static-1.4002",
  "policy-lib": "static-1.7057",
  "react-colorpicker": "static-2.10468",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10696",
  "embedded-academy-lib": "static-1.15405",
  "hubs-service-types": "static-1.1519",
  "FileManagerLib": "static-1.40036",
  "NamespacedHubStyle": "static-2.9235",
  "FileManagerCore": "static-1.39895",
  "content-assistance-lib": "static-1.8149",
  "layout-dnd-components": "static-1.12908",
  "layout-dnd-utils": "static-1.11883",
  "ui-addon-emoji-picker": "static-1.10146",
  "ui-brand-identity-lib": "static-1.16286",
  "InboxConnectUtils": "static-4.15483",
  "meetings-connect-utils-lib": "static-1.7870",
  "breeze-engine-chat-components": "static-1.586",
  "breeze-engine-core": "static-1.886",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3268",
  "adobe-sign-auth-lib": "static-1.380",
  "ads-unified-auth-lib": "static-1.1133",
  "google-sheets-integration-lib": "static-1.957",
  "microsoft-drive-auth-lib": "static-1.53",
  "surveymonkey-integration-lib": "static-1.400",
  "slack-ui-library": "static-1.10659",
  "calling-orchestration-schema": "static-1.36719",
  "crm-record-cards-service-types": "static-1.3759",
  "content-media-composition-data-lib": "static-1.13152",
  "content-media-compositions": "static-2.17159",
  "media-bridge-lib": "static-1.19353",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16292",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4771",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14865",
  "audio-components": "static-1.6289",
  "FileManagerImages": "static-1.37547",
  "video-components": "static-1.14088",
  "breeze-artifacts-sdk": "static-1.225",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4793",
  "video-embed": "static-1.36578",
  "ui-addon-video-player": "static-1.8964",
  "ui-coaching-tips": "static-1.29241",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10208",
  "academy-service-client": "static-1.3949",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4665",
  "trellis-ecosystem": "static-1.7579",
  "ui-addon-react-router-dom": "static-1.9798",
  "wootric-nps": "static-1.7173",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4420",
  "growth-onboarding-feedback-components": "static-1.6845",
  "advanced-menus-core": "static-1.15525",
  "advanced-menus-lib": "static-1.12404",
  "ExportDialog": "static-6.10639",
  "ui-memberships-settings-lib": "static-1.34768",
  "marketplace-ui-apps-core": "static-1.19164",
  "marketplace-ui-common": "static-1.20632",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15524",
  "simple-menus-lib": "static-1.17041",
  "developer-experience-shared-components": "static-1.10764",
  "immutable-less": "static-1.4911",
  "marketplace-ui-client-types": "static-1.18039",
  "ui-addon-integrations-directory-panel": "static-2.8287",
  "ui-extensibility-client-types": "static-1.4181",
  "ai-settings-ui-library": "static-1.8272",
  "nav-meta": "static-1.30376",
  "ui-product-approvals-common": "static-1.917",
  "apps-service-types": "static-1.4001",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3462"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35148",
  "atom": "/atom/static-1.5346",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2755",
  "client-types": "/client-types/static-1.494",
  "cssUtils": "/cssUtils/static-1.877",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40798",
  "customer-data-objects": "/customer-data-objects/static-1.7948",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8359",
  "documents-lib": "/documents-lib/static-1.35153",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.362",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86491",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4988",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2444",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5855",
  "hs-test-utils": "/hs-test-utils/static-1.8289",
  "hub-http": "/hub-http/static-1.6473",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12051",
  "HubStyleTokens": "/HubStyleTokens/static-2.11744",
  "I18n": "/I18n/static-7.1665",
  "icons": "/icons/static-2.675",
  "jasmine-immutable": "/jasmine-immutable/static-1.3283",
  "jasmine-runner": "/jasmine-runner/static-1.6713",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7413",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3158",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5658",
  "quartz": "/quartz/static-1.7396",
  "react": "/react/static-7.191",
  "react-dlb": "/react-dlb/static-1.87",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16972",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5528",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8440",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8361",
  "reporting-data": "/reporting-data/static-1.68653",
  "reporting-reports": "/reporting-reports/static-1.68330",
  "reporting-snowflake": "/reporting-snowflake/static-1.57270",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10586",
  "reporting-visualizations": "/reporting-visualizations/static-1.60728",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9210",
  "sanitize": "/sanitize/static-1.4736",
  "sanitize-text": "/sanitize-text/static-1.8412",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2008",
  "signup-constants": "/signup-constants/static-1.19538",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8320",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "superstore": "/superstore/static-1.5017",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5016",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11246",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11356",
  "ui-images": "/ui-images/static-2.1233",
  "UIComponents": "/UIComponents/static-3.8690",
  "usage-tracker": "/usage-tracker/static-1.7617",
  "usage-tracker-container": "/usage-tracker-container/static-1.7607",
  "usage-tracker-core": "/usage-tracker-core/static-1.7467",
  "viral-links-lib": "/viral-links-lib/static-1.7334",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9918",
  "foundations-components": "/foundations-components/static-1.8420",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1174",
  "quartz-core": "/quartz-core/static-1.6615",
  "quick-fetch": "/quick-fetch/static-1.4104",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4923",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11404",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18333",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3591",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3673",
  "quartz-webpack": "/quartz-webpack/static-1.3620",
  "foundations-assets": "/foundations-assets/static-1.5144",
  "foundations-theming": "/foundations-theming/static-1.4728",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10550",
  "hubspotter-http": "/hubspotter-http/static-1.4836",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7510",
  "crm-message-bus": "/crm-message-bus/static-1.43670",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23233",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13290",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13440",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10088",
  "events-data-lib": "/events-data-lib/static-1.501",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4195",
  "hs-resources": "/hs-resources/static-1.452",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4030",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1259",
  "onboarding-scopes": "/onboarding-scopes/static-1.6715",
  "onboarding-tours": "/onboarding-tours/static-1.17061",
  "pulse": "/pulse/static-1.885",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14393",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2521",
  "trellis-components": "/trellis-components/static-1.2540",
  "trellis-theming": "/trellis-theming/static-1.1227",
  "ui-addon-teams": "/ui-addon-teams/static-1.21868",
  "quartz-auth": "/quartz-auth/static-1.1071",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9344",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5303",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9628",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-properties": "/customer-data-properties/static-1.52473",
  "forms-ai-lib": "/forms-ai-lib/static-1.4710",
  "forms-utils-lib": "/forms-utils-lib/static-1.13039",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5903",
  "react-dnd-compat": "/react-dnd-compat/static-1.4876",
  "react-tinymce": "/react-tinymce/static-1.55904",
  "tinymce-config": "/tinymce-config/static-2.55030",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10617",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3713",
  "HeadJS": "/HeadJS/static-2.791",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3400",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.266",
  "ui-fonts": "/ui-fonts/static-1.1006",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4577",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1061",
  "web-vitals": "/web-vitals/static-1.11",
  "batch-promise": "/batch-promise/static-1.1802",
  "external-options-client-types": "/external-options-client-types/static-1.4313",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7153",
  "quartz-i18n": "/quartz-i18n/static-1.1071",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8187",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3959",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "growth-payments-core": "/growth-payments-core/static-1.26102",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5139",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1445",
  "quartz-routing": "/quartz-routing/static-1.826",
  "hs-story-utils": "/hs-story-utils/static-1.9687",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.496",
  "seat-types-lib": "/seat-types-lib/static-1.655",
  "timezone-utils": "/timezone-utils/static-2.5507",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4689",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.30",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.571",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.405",
  "quartz-test": "/quartz-test/static-1.1071",
  "quartz-tracking": "/quartz-tracking/static-1.775",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.333",
  "chirp-fetch": "/chirp-fetch/static-1.2154",
  "merchandise-lib": "/merchandise-lib/static-1.274",
  "purchase-motions-components": "/purchase-motions-components/static-1.6299",
  "salesImages": "/salesImages/static-1.532",
  "ts-schema": "/ts-schema/static-1.4267",
  "bender-build-tools": "/bender-build-tools/static-1.3397",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3211",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1589",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4916",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3986",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4321",
  "event-emitter": "/event-emitter/static-1.1214",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.272",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3882",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19146",
  "growth-data-modal": "/growth-data-modal/static-1.5838",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3323",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2622",
  "navigation-components": "/navigation-components/static-1.18739",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5275",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1127",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10526",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7907",
  "ui-universal-auth": "/ui-universal-auth/static-1.9320",
  "user-context": "/user-context/static-1.5378",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.388",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10548",
  "magpie-lib": "/magpie-lib/static-1.5727",
  "navigation-messaging": "/navigation-messaging/static-1.8066",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22715",
  "copilot-toolkit": "/copilot-toolkit/static-1.11774",
  "cms-field-types": "/cms-field-types/static-1.5075",
  "content-icons-ui": "/content-icons-ui/static-1.2324",
  "integrations-lib": "/integrations-lib/static-1.16957",
  "calling-global-api": "/calling-global-api/static-1.65432",
  "calling-internal-common": "/calling-internal-common/static-1.31579",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66814",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59108",
  "commerce-products-lib": "/commerce-products-lib/static-1.10443",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4491",
  "crm-links": "/crm-links/static-1.6587",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9877",
  "file-manager-components": "/file-manager-components/static-1.24396",
  "formula-editor": "/formula-editor/static-1.14693",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4398",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.896",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49577",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4155",
  "property-value-citations": "/property-value-citations/static-1.3087",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.55",
  "smart-property-lib": "/smart-property-lib/static-1.8204",
  "tiered-pricing": "/tiered-pricing/static-1.1893",
  "topics-actions-lib": "/topics-actions-lib/static-1.425",
  "trial-components-library": "/trial-components-library/static-1.14044",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9335",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20252",
  "tinymce-themes": "/tinymce-themes/static-1.57000",
  "data-token-picker": "/data-token-picker/static-1.16834",
  "hub-http-contrib": "/hub-http-contrib/static-1.3298",
  "interframe": "/interframe/static-3.5016",
  "tinymce-data": "/tinymce-data/static-1.41115",
  "tinymce-plugins": "/tinymce-plugins/static-1.58144",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5476",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7058",
  "ui-addon-opt": "/ui-addon-opt/static-4.8627",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.598",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6302",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2437",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2650",
  "user-context-client": "/user-context-client/static-1.4769",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5187",
  "nest": "/nest/static-1.496",
  "reactive-lib": "/reactive-lib/static-1.982",
  "simple-logging-lib": "/simple-logging-lib/static-1.3311",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1116",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18264",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1608",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14372",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5868",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8038",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10629",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.834",
  "calling-error-reporting": "/calling-error-reporting/static-1.31586",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11300",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6799",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1942",
  "customer-data-tracking": "/customer-data-tracking/static-1.7142",
  "commerce-permissions": "/commerce-permissions/static-1.1037",
  "products-iframe-lib": "/products-iframe-lib/static-1.8520",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10932",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6703",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10633",
  "sales-views-client-types": "/sales-views-client-types/static-1.4517",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10018",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4412",
  "video-components-external": "/video-components-external/static-1.12086",
  "video-data-lib": "/video-data-lib/static-1.35744",
  "bark-lib": "/bark-lib/static-1.16767",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6150",
  "react-codemirror": "/react-codemirror/static-1.10899",
  "data-agent-kit": "/data-agent-kit/static-1.591",
  "feedback-loader": "/feedback-loader/static-1.29754",
  "fsm": "/fsm/static-1.4002",
  "policy-lib": "/policy-lib/static-1.7057",
  "react-colorpicker": "/react-colorpicker/static-2.10468",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10696",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15405",
  "hubs-service-types": "/hubs-service-types/static-1.1519",
  "FileManagerLib": "/FileManagerLib/static-1.40036",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9235",
  "FileManagerCore": "/FileManagerCore/static-1.39895",
  "content-assistance-lib": "/content-assistance-lib/static-1.8149",
  "layout-dnd-components": "/layout-dnd-components/static-1.12908",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11883",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10146",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16286",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15483",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7870",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.586",
  "breeze-engine-core": "/breeze-engine-core/static-1.886",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3268",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.380",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1133",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.957",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.53",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.400",
  "slack-ui-library": "/slack-ui-library/static-1.10659",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36719",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13152",
  "content-media-compositions": "/content-media-compositions/static-2.17159",
  "media-bridge-lib": "/media-bridge-lib/static-1.19353",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16292",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4771",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14865",
  "audio-components": "/audio-components/static-1.6289",
  "FileManagerImages": "/FileManagerImages/static-1.37547",
  "video-components": "/video-components/static-1.14088",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.225",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4793",
  "video-embed": "/video-embed/static-1.36578",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8964",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29241",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10208",
  "academy-service-client": "/academy-service-client/static-1.3949",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4665",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7579",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9798",
  "wootric-nps": "/wootric-nps/static-1.7173",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4420",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6845",
  "advanced-menus-core": "/advanced-menus-core/static-1.15525",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12404",
  "ExportDialog": "/ExportDialog/static-6.10639",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34768",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19164",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20632",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15524",
  "simple-menus-lib": "/simple-menus-lib/static-1.17041",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10764",
  "immutable-less": "/immutable-less/static-1.4911",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18039",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8287",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4181",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8272",
  "nav-meta": "/nav-meta/static-1.30376",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.917",
  "apps-service-types": "/apps-service-types/static-1.4001",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3462"
}
};
